import { z } from 'zod';
import { isoDateTime } from './common.js';
export const agentToneSchema = z.enum(['concise', 'friendly', 'formal']);
export const agentLanguageSchema = z.enum(['auto', 'uz-Latn', 'uz-Cyrl', 'ru', 'en']);
/** Mirrors SYSTEM_PROMPT_MAX in core; the use-case checks it again. */
export const SYSTEM_PROMPT_MAX_CHARS = 2000;
export const agentSettingsSchema = z.object({
    /** Absent: the deployment's default answer model (the first of `models`). */
    model: z.string().optional(),
    language: agentLanguageSchema,
    tone: agentToneSchema,
    systemPrompt: z.string(),
    updatedAt: isoDateTime.optional(),
    updatedBy: z.object({ id: z.string(), name: z.string() }).optional(),
});
export const agentSettingsInputSchema = z.object({
    model: z.string().min(1).optional(),
    language: agentLanguageSchema,
    tone: agentToneSchema,
    systemPrompt: z.string().max(SYSTEM_PROMPT_MAX_CHARS),
});
//# sourceMappingURL=agent.js.map